// AUTO-GENERATED by scripts/gen-backgrounds.ts — do not edit by hand.
// Drop photos (.jpg/.jpeg/.png/.webp/.avif) into src/backgrounds/background_images/ and run:
//   bun run gen-backgrounds
import bg0 from "./background_images/bg-IMG_0891.jpg";
import bg1 from "./background_images/bg-IMG_0893.jpg";
import bg2 from "./background_images/bg-IMG_0960.jpg";
import bg3 from "./background_images/bg-IMG_1129.jpg";
import bg4 from "./background_images/bg-IMG_1133.jpg";
import bg5 from "./background_images/bg-IMG_1170.jpg";
import bg6 from "./background_images/bg-IMG_1190.jpg";
import bg7 from "./background_images/bg-IMG_1205.jpg";
import bg8 from "./background_images/bg-IMG_1368.jpg";
import bg9 from "./background_images/bg-IMG_1722.jpg";
import bg10 from "./background_images/bg-IMG_1734.jpg";
import bg11 from "./background_images/bg-IMG_1821.jpg";
import bg12 from "./background_images/bg-IMG_1834.jpg";
import bg13 from "./background_images/bg-IMG_1918.jpg";
import bg14 from "./background_images/bg-IMG_1946.jpg";
import bg15 from "./background_images/bg-IMG_1981.jpg";
import bg16 from "./background_images/bg-IMG_2026.jpg";
import bg17 from "./background_images/bg-IMG_2066.jpg";
import bg18 from "./background_images/bg-IMG_2099.jpg";
import bg19 from "./background_images/bg-IMG_2143.jpg";
import bg20 from "./background_images/bg-IMG_2173.jpg";
import bg21 from "./background_images/bg-IMG_2202.jpg";
import bg22 from "./background_images/bg-IMG_2203.jpg";
import bg23 from "./background_images/bg-IMG_3040.jpg";
import bg24 from "./background_images/bg-IMG_3818.jpg";
import bg25 from "./background_images/bg-IMG_7002.jpg";
import bg26 from "./background_images/bg-IMG_9734.jpg";

export const backgroundImages: string[] = [
  bg0,
  bg1,
  bg2,
  bg3,
  bg4,
  bg5,
  bg6,
  bg7,
  bg8,
  bg9,
  bg10,
  bg11,
  bg12,
  bg13,
  bg14,
  bg15,
  bg16,
  bg17,
  bg18,
  bg19,
  bg20,
  bg21,
  bg22,
  bg23,
  bg24,
  bg25,
  bg26
];
